import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenderFeedbackComponent } from './render-feedback.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [RenderFeedbackComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule
  ],
  exports: [
    RenderFeedbackComponent
  ]
})
export class RenderFeedbackModule { }
